import { xlCol, xlColq } from "../../common/constants";
export const actionList = [{name:'Assign',id:0},{name:"Change",id:1},{name:"Cancel",id:2}]
export const tableHeaders = [
    { headerName: 'LR Number \nOffline LR No', field: 'lrNumber', xlCol: xlCol },
    { headerName: 'Receive Date\nChallan No.', field: 'receiveDate', xlCol: xlCol },
    { headerName: 'Source City\nSource Branch', field: 'sourceCityBranch', xlCol: xlCol },
    { headerName: 'Destination City\nDestination Branch', field: 'destinationCityBranch', xlCol: xlCol },
    { headerName: 'Payment Type\n LR Due Amt.', field: 'paymentTypeAmt', xlCol: xlCol },
    { headerName: `Total No of Units \nPayment Method`, field: 'totalNoOfUnits', xlCol: xlCol },
    { headerName: 'Freight \nDelivery Cartage', field: 'freight', xlCol: xlCol },
    { headerName: 'Receiver Name\nDelivery Hamali', field: 'receverName', xlCol: xlCol },
    { headerName: 'Receiver Number \nDelivery Op. Hamali', field: 'receiverNumber', xlCol: xlCol },
    { headerName: 'Assigned By User \nDemurrage Chg.', field: 'assignedBy', xlCol: xlCol },
    { headerName: 'Assigned Date \nDelivery Discount', field: 'assignedDate', xlCol: xlCol },
    { headerName: 'OFD Status \n Delivery GST', field: 'ofdStatus', xlCol: xlCol },
    { headerName: 'Total Outstanding', field: 'outDeliveryDate', xlCol: xlColq },
  ];

  export const tableHeadersfilter = [
    { headerName: '', field: 'LRNO', xlCol: xlCol },
    { headerName: '', field: 'ManualLRNo', xlCol: xlColq },
    { headerName: '', field: 'ReceiptDate', xlCol: xlCol },
    { headerName: '', field: 'ChallanNo', xlCol: xlCol },
    { headerName: '', field: 'BookingCity', xlCol: xlCol },
    { headerName: '', field: 'BookingBranch', xlCol: xlColq },
     { headerName: '', field: 'BookingCity', xlCol: xlCol },
    { headerName: '', field: 'DestinationCity', xlCol: xlColq },
    { headerName: '', field: 'DestinationBranch', xlCol: xlCol },
    { headerName: '', field: 'DueAmount', xlCol: xlCol },
  ];
  export const tablePending = [
    { headerName: 'SN', field: 'SN', xlCol: xlCol,weight:30, showfilter: false },
    { headerName: 'LR Number', field: 'LRNO', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Offline LR No', field: 'ManualLRNo', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Payment Type', field: 'PaymentTypeName', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Source City', field: 'BookingCity', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Source Branch', field: 'BookingBranch', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Destination City', field: 'DestinationCity', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Destination Branch', field: 'DestinationBranch', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Receive Date', field: 'ReceiveDateTime', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: `Units`, field: 'Units', xlCol: xlColq ,weight:30, showfilter: true},
    { headerName: `LR Due Amt.`, field: 'DueAmount', xlCol: xlColq, weight:30,showfilter: true},
    { headerName: 'Receiver Name', field: 'RecName', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Receiver Number', field: 'RecMobileNo', xlCol: xlCol,weight:30, showfilter: true },
  ];
  export const tableStatus = [
    ...tablePending,
    { headerName: 'Assigned To User', field: 'AssignedUser', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Assigned Date', field: 'DeliveryAssignedDate', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Assigned/Returned By User', field: 'AssignedByUser', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Status', field: 'Status', xlCol: xlCol,weight:30, showfilter: true },
    { headerName: 'Download  POD', field: 'PODLink', xlCol: xlCol,weight:30, showfilter: false },
  ]
  export const excelHeaderDataList = [
    { header: 'From Date', field: 'fromDate', xlCol: xlCol },
    { header: 'To Date', field: 'toDate', xlCol: xlCol },
    { header: 'City Name', field: 'CityName', xlCol: xlCol },
    { header: 'Branch Name', field: 'BranchName', xlCol: xlCol },
    { header: 'User Name', field: 'UserName', xlCol: xlCol },
    { header: 'Status', field: 'Status', xlCol: xlCol },
  ]
  